import React, { useContext, useState, useEffect } from "react";
import { Flex } from "@src/components/Boxes";
import styled from "@emotion/styled";
import Link from "@src/components/UTMLink";
import Translate from "@src/components/translation/Translate";
import { CloseIcon } from "@src/components/nessie-web";
import { getRelativePath } from "@src/utils/routes";
import { mediaQueries } from "@src/styles/theme";
import Container from "@src/components/Container";
import { TranslationContext } from "@src/components/translation/TranslationContext";
import { logEvent } from "@src/utils/logClient";

const Header = styled("h2")`
  font-size: 16px;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.14);
  color: #fff;
  line-height: 1.1;
  font-weight: 200;
  z-index: 3;
  text-align: center;
  margin-bottom: 0;
  margin-top: 0px;
  ${mediaQueries[1]} {
    font-size: 24px;
  }
`;
const CloseButton = styled.button`
  width: 40px;
  height: 40px;
  color: #fff;
  font-size: 24px;
  z-index: 999;
  transition: opacity 0.4s;
  background: transparent;
  outline: 0;
  border: 0;
  cursor: pointer;
  ${mediaQueries[1]} {
    font-size: 40px;
    width: 55px;
    height: 55px;
  }
`;

type SchoolClosureBannerSectionProps = {
  closeFunction: () => void;
  CDSBannerCase: string;
};

const SchoolClosureBannerSection: React.FC<SchoolClosureBannerSectionProps> = ({ closeFunction, CDSBannerCase }) => {
  const t = useContext(TranslationContext);
  const [currentCase, setCurrentCase] = useState(CDSBannerCase);
  useEffect(() => {
    setCurrentCase(CDSBannerCase);
    logEvent(`web.external.schools_banner.load.${currentCase}`);
  }, [CDSBannerCase]);

  const textOptions = {
    case1: {
      text: "directus.homepage_copy_experiments.Case_1_Text",
      cta: "directus.homepage_copy_experiments.Case_1_CTA",
      link: "https://teach.classdojo.com/#/classdojoSchoolSignup?stage=signup&interest=true&utm_source=external",
    },
    case2: {
      text: "directus.homepage_copy_experiments.Case_2_Text",
      cta: "directus.homepage_copy_experiments.Case_2_CTA",
      link: "https://teach.classdojo.com/#/classdojoSchoolSignup?interest=true&utm_source=external",
    },
    case3: {
      text: "directus.homepage_copy_experiments.Case_3_Text",
      cta: "directus.homepage_copy_experiments.Case_3_CTA",
      link: "https://teach.classdojo.com/#/classdojoSchoolSignup?make_official=true&utm_source=external",
    },
    case4: {
      text: "directus.homepage_copy_experiments.Case_4_Text",
      cta: "directus.homepage_copy_experiments.Case_4_CTA",
      link: getRelativePath("/schools/?utm_source=external"),
    },
  };

  return (
    <Flex
      padding="12px"
      position="relative"
      justifyContent="center"
      alignItems="center"
      backgroundColor={"#00aeef"}
      width="100%"
      overflow="hidden"
      height="60px"
    >
      <Container>
        <a
          href={textOptions[currentCase].link}
          target={currentCase !== "case4" ? "_blank" : "_self"}
          rel="noreferrer"
          onClick={() => {
            logEvent(`web.external.schools_banner.click.${currentCase}`);
          }}
        >
          <Header>
            <Translate path={textOptions[currentCase].text} />{" "}
            <u>
              <Translate path={textOptions[currentCase].cta} />
            </u>
          </Header>
        </a>
      </Container>
      <CloseButton aria-label={t.translate("layouts.main.close")?.toString() ?? ""} onClick={() => closeFunction()}>
        <CloseIcon color="dt_white" />
      </CloseButton>
    </Flex>
  );
};

export default SchoolClosureBannerSection;
